import {
  dataAttribute,
  DataAttributes,
  FontSizes,
  FontWeights,
  ILinkProps,
  Link,
  mergeStyleSets,
  Stack
} from "@bps/fluent-ui";

export interface FieldsetActionButtonProps {
  text: string | React.ReactNode;
  props?: ILinkProps;
  onRender?: (
    props?: Pick<FieldsetActionButtonProps, "props" | "text">,
    defaultRender?: (
      text: React.ReactNode,
      linkProps: ILinkProps | undefined
    ) => JSX.Element | undefined
  ) => React.ReactNode;
}

export const FieldsetActionButton = ({
  onRender,
  text,
  props
}: FieldsetActionButtonProps) => {
  const linkButton = (
    text: React.ReactNode,
    props: ILinkProps | undefined
  ): JSX.Element => {
    return (
      <Link
        {...props}
        {...dataAttribute(DataAttributes.Element, "fieldset-action-link")}
        styles={mergeStyleSets(props?.styles, {
          root: {
            marginLeft: "auto",
            fontSize: FontSizes.small,
            fontWeight: FontWeights.regular
          }
        })}
      >
        {text}
      </Link>
    );
  };

  return (
    <Stack horizontal tokens={{ childrenGap: 8 }}>
      {onRender
        ? onRender({ props, text }, linkButton)
        : linkButton(text, props)}
    </Stack>
  );
};
